"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskManagerFilterTaskStatus = exports.TaskManagerFilterTaskType = void 0;
var TaskManagerFilterTaskType;
(function (TaskManagerFilterTaskType) {
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["WidgetRequest"] = 0] = "WidgetRequest";
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["Automation"] = 1] = "Automation";
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["Form"] = 2] = "Form";
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["PaymentWritebackFailure"] = 3] = "PaymentWritebackFailure";
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["DirectBookingWritebackFailure"] = 4] = "DirectBookingWritebackFailure";
    TaskManagerFilterTaskType[TaskManagerFilterTaskType["Custom"] = 5] = "Custom";
})(TaskManagerFilterTaskType = exports.TaskManagerFilterTaskType || (exports.TaskManagerFilterTaskType = {}));
var TaskManagerFilterTaskStatus;
(function (TaskManagerFilterTaskStatus) {
    TaskManagerFilterTaskStatus[TaskManagerFilterTaskStatus["Open"] = 0] = "Open";
    TaskManagerFilterTaskStatus[TaskManagerFilterTaskStatus["InProgress"] = 1] = "InProgress";
    TaskManagerFilterTaskStatus[TaskManagerFilterTaskStatus["Completed"] = 2] = "Completed";
    TaskManagerFilterTaskStatus[TaskManagerFilterTaskStatus["Canceled"] = 3] = "Canceled";
})(TaskManagerFilterTaskStatus = exports.TaskManagerFilterTaskStatus || (exports.TaskManagerFilterTaskStatus = {}));
//# sourceMappingURL=ClinicUserFilterJsonType.js.map